import { formValidation } from "./_vendor/@form-validation/esm/bundle/popular.min.js";
import { AutoFocus } from "./_vendor/@form-validation/esm/plugin-auto-focus";
import { Message } from "./_vendor/@form-validation/esm/plugin-message";
import { SubmitButton } from "./_vendor/@form-validation/esm/plugin-submit-button";
import { Trigger } from "./_vendor/@form-validation/esm/plugin-trigger";

import {
    Messages,
    SetMessageContainer,
    InvalidFieldEventHandler,
    ValidFieldEventHandler,
} from "./_form";
import runRecaptchaAndSubmit from "./_recaptcha.js";

let fv;
let form;
let submitButton;

const validateForm = () => {
    fv = formValidation(form, {
        fields: {
            first_name: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                },
            },
            last_name: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                },
            },
            telephone: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                },
            },
            email: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                    emailAddress: {
                        message: Messages.email,
                    },
                },
            },
            message: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                },
            },
            enquiry_source: {
                validators: {
                    notEmpty: {
                        message: Messages.select,
                    },
                },
            },
            data_collection_consent: {
                validators: {
                    notEmpty: {
                        message: Messages.required,
                    },
                },
            },
        },
        plugins: {
            autoFocus: new AutoFocus(),
            message: new Message({
                clazz: "error",
                container: (field, element) => SetMessageContainer(element),
            }),
            submitButton: new SubmitButton(),
            trigger: new Trigger(),
        },
    })
        .on("core.field.invalid", (fieldName) => {
            InvalidFieldEventHandler(fv, fieldName);
        })
        .on("core.field.valid", (fieldName) => {
            ValidFieldEventHandler(fv, fieldName);
        })
        .on("core.form.valid", () => {
            submitButton.setAttribute("disabled", true);
            runRecaptchaAndSubmit(form);
        });
};

const ContactForm = () => {
    form = document.querySelector(".js-contact");
    if (form === null) {
        return;
    }

    submitButton = form.querySelector('button[type="submit"]');

    validateForm();
};

export default ContactForm;
